import Data from "source/app/services/Data";
import { IGoal } from "motw_core/Entity/IGoal";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { HandleLoggingMatchingGoalAsync } from "source/app/presentation/MainPanel/Calendar/DoneSwitch/Helpers/HandleLoggingMatchingGoalAsync";
import { HandleFinishingCalendarEventAheadOfTimeAsync } from "source/app/presentation/MainPanel/Calendar/DoneSwitch/Helpers/HandleFinishingCalendarEventAheadOfTimeAsync";
import { logRepository } from "motw_core/Repositories/LogRepository";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import {
    OnErrorAddLogEntry,
    OnFinishAddLogEntry,
} from "source/app/services/Log/AddEntry";
import * as toastr from "toastr";

export async function AddLogEntryForCalendarEventCompletionAsync(
    calendarEvent: CalendarEvent,
    matchingGoal?: IGoal
) {
    if (matchingGoal) {
        await HandleLoggingMatchingGoalAsync(matchingGoal);
    } else {
        await logRepository.AddOneTimeLogEntryAsync(
            "Achieving", // should be an enum or reference
            calendarEvent.eventData.name,
            ClientDataProvider,
            OnErrorAddLogEntry,
            OnFinishAddLogEntry
        );

        toastr.info(
            `Event "${calendarEvent.eventData.name}" has been logged`,
            ``,
            {
                timeOut: 1000,
            }
        );
    }

    await HandleFinishingCalendarEventAheadOfTimeAsync(calendarEvent);

    Data.Load.AllAsync();
}
